/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, CardText, CardTitle, Card } from "reactstrap";
import { BsChevronRight } from "react-icons/bs";
import { IoChevronForwardOutline } from "react-icons/io5";

import { Link, useNavigate } from "react-router-dom";
import EditRouteModal from "../../../components/Modals/EditRouteModal";
import PointsListingModal from "../../../components/Modals/PointsListingModal";
import swal from "sweetalert";
import { deleteRouteFromList } from "../../../services/myRoute.service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import NoDataFound from "../../../components/NoDataFound/NoDataFound";
import moment from "moment-timezone";
import Pagination from "../../../components/Pagination/Pagination";
import edit_icon from "../../../assets/edit_icon.svg";
import det_icon from "../../../assets/del_icon.svg";
import "../myroutes.scss";
import UserNotLoggedIn from "../../../components/UserNotLoggedIn/UserNotLoggedIn";
import { MdDelete } from "react-icons/md";
import { RiEditBoxLine } from "react-icons/ri";
import delete_image from "../../../assets/rafiki.svg";

const GridView = ({
  route,
  fetchUserRoutes,
  pointName,
  setPointName,
  totalCount,
  currentPage,
  setCurrentPage,
  pageSize,
  isUserLoggedIn,
}) => {
  const [showEditRouteModal, setShowEditRouteModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [id, setId] = useState("");
  const [routeName, setRouteName] = useState(null);
  const [routeDate, setRouteDate] = useState(null);
  const [totalRecords, setTotalRecords] = useState("");

  const userName = useSelector(
    (state) => state.userDetailReducer.userData.userName
  );
  const toggleEditRoute = () => setShowEditRouteModal(!showEditRouteModal);

  const editRoute = (dt) => {
    let istDate;
    if (dt?.routeStartingDate !== null) {
      istDate = moment(`${dt?.routeStartingDate}Z`).tz("Asia/Kolkata");
    } else {
      istDate = null;
    }
    setShowEditRouteModal(true);
    setId(dt?.routeID);
    setRouteName(dt?.routeName);
    setRouteDate(istDate);
  };

  useEffect(() => {
    setTotalRecords(totalCount);
  }, [totalCount]);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return route?.slice(0, pageSize);
  }, [currentPage, route]);

  const deleteRoute = async (id, deleteRouteName) => {
    const isDelete = await swal({
      title: "Are you sure?",
      text: `You are about to delete the ${deleteRouteName} Route. Do you wish to continue?`,
      icon: delete_image,
      buttons: ["No", "Yes"],
    });
    if (isDelete) {
      try {
        console.log("deleting.....", userName, id);
        const response = await deleteRouteFromList({
          userName: userName,
          routeID: id,
        });
        if (response && response.status === 200) {
          swal("Deleted!", "Your route has been deleted!", "success");
          fetchUserRoutes();
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "Oops.. something went wrong, try again !!!",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    }
  };

  const showStartDate = (dateTime) => {
    let istDate = moment(`${dateTime}Z`).tz("Asia/Kolkata");

    let today = new Date(istDate);
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();

    today = dd + "/" + mm + "/" + yyyy;
    return today;
  };

  const navigate = useNavigate();

  const handleNavigateToDetail = (routeID, routeName) => {
    navigate(`/my-routes-detail/${routeID}/${routeName}`);
  };

  return (
    <div className="grid_view">
      <EditRouteModal
        showEditRouteModal={showEditRouteModal}
        setShowEditRouteModal={setShowEditRouteModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        routeName={routeName}
        routeDate={routeDate}
        setRouteDate={setRouteDate}
        pointName={pointName}
        setPointName={setPointName}
        id={id}
        setRouteName={setRouteName}
        toggleEditRoute={toggleEditRoute}
        fetchUserRoutes={fetchUserRoutes}
      />
      <PointsListingModal
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <div className="routes-container">
        {isUserLoggedIn ? (
          <>
            {currentTableData?.length === 0 ||
            currentTableData === undefined ? (
              <NoDataFound />
            ) : (
              currentTableData?.map((item) => (
                <section
                  key={item?.routeID}
                  className="route-card-wrapper mb-4"
                >
                  <div
                    className="nt-card"
                    onClick={() =>
                      handleNavigateToDetail(item?.routeID, item?.routeName)
                    }
                  >
                    <div className="card_header">
                      <Link
                        to={`/my-routes-detail/${item?.routeID}/${item?.routeName}`}
                      >
                        <h5 className="card-title">{item?.routeName}</h5>
                      </Link>
                      <Link
                        to={`/my-routes-detail/${item?.routeID}/${item?.routeName}`}
                      >
                        <IoChevronForwardOutline size={22} />
                      </Link>
                    </div>
                    <div className="card_items_content">
                      <div className="card_left_section">
                        <div className="card_content">
                          {item?.routeStartingDate && (
                            <div className="card-text">
                              <h5> Trip Start Date:</h5>
                              <p>{showStartDate(item?.routeStartingDate)}</p>
                            </div>
                          )}

                          {item?.place?.cityE && (
                            <div className="card-text">
                              <h5>City:</h5> <p>{item?.place?.cityE}</p>
                            </div>
                          )}

                          {item?.place?.stateE && (
                            <div className="card-text">
                              <h5>State:</h5> <p>{item?.place?.stateE}</p>
                            </div>
                          )}

                          {item?.place?.title && (
                            <div className="card-text">
                              <h5>Title:</h5> <p>{item?.place?.title}</p>
                            </div>
                          )}
                        </div>
                        <div className="card_footer_left">
                          <h5>Number of Points -</h5> <p>{item?.pointCount}</p>
                        </div>
                      </div>
                      <div className="card_right_section">
                        <div className="card_footer_right">
                          <Link
                            to="#"
                            className="edit"
                            onClick={(e) => {
                              e.stopPropagation();
                              editRoute(item);
                            }}
                          >
                            <img src={edit_icon} alt="edit" width="20" />
                          </Link>
                          <Link
                            to="#"
                            className="delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteRoute(item?.routeID, item?.routeName);
                            }}
                          >
                            {/* <img src={det_icon} alt="delete" /> */}
                            <MdDelete size={22} />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              ))
            )}
          </>
        ) : (
          <UserNotLoggedIn />
        )}
      </div>

      {isUserLoggedIn ? (
        <>
          {currentTableData?.length === 0 ||
          currentTableData === undefined ? null : (
            <Pagination
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={totalRecords > 0 ? totalRecords : null}
              pageSize={pageSize}
              onPageChange={(currentPage) => setCurrentPage(currentPage)}
            />
          )}
        </>
      ) : null}
    </div>
  );
};
export default GridView;
